/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeMedias.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Media constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *  
 *  Created:    Wednesday, January 15, 2025 - 11:53 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      01/15/2025  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2025 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const UPDATE_MEDIAGROUPID = 'UPDATE_MEDIAGROUPID';